import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit'

type AccountsState = {
  page: number;
  perPage: number;
  filters: Record<string, any>;
}

const initialState: AccountsState = {
  page: 1,
  perPage: 24,
  filters: {
  }
};

const accountsSlice = createSlice({
  name: 'accounts',
  initialState,
  reducers: {
      setPage: (state, action: PayloadAction<number>) => {
        state.page = action.payload;
      },
      setFilters(state, action: PayloadAction<Record<string, any>>) {
        state.filters = action.payload
      },
      setFilter(state, action: PayloadAction<{ key: string, value: any }>) {
        const { key, value } = action.payload
        state.filters[key] = value
        state.page = 1
      },
      resetFilters(state) {
        state.page = 1;
        state.perPage = 24;
        state.filters = {}
      }
    }
});

export const { setPage, setFilters, resetFilters } = accountsSlice.actions
export default accountsSlice;
